var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Page',{tag:"component",on:{"changePassword":function($event){return _vm.$emit('changePassword')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }